<!--
 * @Author: zhangyi
 * @Date: 2021-05-28 15:30:34
 * @LastEditors: zhangyi
 * @LastEditTime: 2021-05-28 17:05:03
 * @Description: file content
 * @FilePath: \trainVideo\src\views\qrcode\index.vue
-->
<template>
  <div ref="div1" :style="{backgroundImage: 'url(' +imgUrl+ ')'}" @click="handleBodyClick"  class="_div">
  </div>
</template>

<script>
import androidImg from './img/android.png'
import androidImg1 from './img/android.png'
import iosImg from './img/ios.png'
export default {
  data(){
    return {
      imgUrl:'',
      androidImg:androidImg,
      androidImg1:androidImg1,
      iosImg:iosImg,
      conheight:'200px'
    }
  },
  
  created(){
    window.addEventListener('resize', this.getHeight());
   
  },
 
  mounted(){
     this.$refs.div1.style.height = this.conheight
    if(this.isWechat()){
        //判断是否是微信浏览器
          if(this.os()==='android'){
             this.imgUrl=androidImg
          }else{
             this.imgUrl=iosImg
          }
      }else{
        if(this.os()==='android'){
          location.href =  'https://pos.pluss.cn/resources/sdk/ylsy-app-release.apk' 
          }
        else if(this.os()==='ios'){
          location.href =  'http://itunes.apple.com/us/app/id1469864386' 
          }
      }
  },

  methods:{
    getHeight(){
        this.conheight=window.innerHeight-40+'px';
        console.log(this.conheight)
    },

    handleBodyClick(){
      if(this.os()==='android'){
         this.imgUrl=androidImg1
        location.href =  'https://pos.pluss.cn/resources/sdk/ylsy-app-release.apk' 
      }else{
         this.imgUrl=iosImg
        location.href =  'http://itunes.apple.com/us/app/id1469864386' 
      } 
    },

    isWechat () {
      //是否微信端
      let ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
         return true    
        }
        else{
          return false
        }
    },

    os () {
        let temp = ''
        let u = navigator.userAgent, app = navigator.appVersion; 
        let  isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;//g 
		    let  isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);   //ios终端 
        if(isAndroid){
          temp = 'android'
        }else if(isIOS){
          temp = 'ios'
        }
        return temp
    }
}
}
</script>

<style scoped>
    ._div{
      font-size: 12px;
      width: 100%;
      background-repeat: no-repeat;
      background-size: cover;
      overflow: hidden;
    }
</style>


